import { render, staticRenderFns } from "./SrmSupplierAccess.vue?vue&type=template&id=baee597a&scoped=true"
import script from "./SrmSupplierAccess.vue?vue&type=script&lang=js"
export * from "./SrmSupplierAccess.vue?vue&type=script&lang=js"
import style0 from "./SrmSupplierAccess.vue?vue&type=style&index=0&id=baee597a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baee597a",
  null
  
)

export default component.exports